export default "__VITE_ASSET__CHfarOUs__"